import { IoIosArrowRoundForward } from 'react-icons/io';
import UserAvatar from '../../avatar/Avatar';
import { useNavigate } from 'react-router-dom';
import useGetUserTier from '../../../services/user/queries/useGetUserTier';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import ROUTES from '../../../routers/Routes';
import TierAvatarProgress from '../../avatar/TierAvatarProgress';
import { useSelector } from 'react-redux';
import { ReducerState } from '@/services/common/lib/reducerState';
import TierIcon from './TierIcon';
import PHNMTokenIcon from '@/components/PHNMTokenIcon';
import { useQuery } from '@tanstack/react-query';
import { getTotalUnpaidRakeback } from '@/services/rake/rake.service';
import { useMemo } from 'react';

const UserWalletMobileCard = () => {
  const user = useSelector((state: ReducerState) => state.auth);
  const navigate = useNavigate();

  const handleClickArrow = () => navigate(ROUTES.MY_HUB);

  const { isLoading, isSuccess, data } = useGetUserTier({
    userId: user.id!,
  });

  const { data: rakebackData, isLoading: isLoadingRakeBack } = useQuery({
    queryKey: ['rakeBackData'],
    queryFn: () => getTotalUnpaidRakeback(),
    staleTime: 60000, // Cache results for 1 minute
  });

  const rakebackAmount = useMemo(() => {
    const amount: number = rakebackData?.data?.amount || 0;

    if (!amount) return amount.toFixed(2);

    return amount < 1 ? amount.toFixed(3) : amount.toFixed(2);
  }, [rakebackData?.data?.amount]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!user || !user.id || !isSuccess || !data) {
    return null;
  }

  const userTier = data.data;

  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex items-center gap-2">
        <TierAvatarProgress className="h-[52px] w-[52px]" small progressPercentage={userTier.tierProgressPercentage}>
          <UserAvatar userId={user.id} className="h-[36px] w-[36px]" />
        </TierAvatarProgress>
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <h2 className="font-manrope text-base font-semibold leading-[22px] text-ph-gray-white">{user.alias}</h2>
            <TierIcon tier={userTier.currentTier?.tier} className="h-5 w-5" />
          </div>

          <div className="flex items-center gap-2">
            <PHNMTokenIcon className="h-5 w-5" />
            <p className="font-manrope text-sm font-semibold text-ph-gray-white">
              {isLoadingRakeBack ? <LoadingSpinner size="4" /> : rakebackAmount}
            </p>
            <span className="font-manrope text-sm font-medium text-ph-gray-evening">Pending</span>
          </div>
        </div>
      </div>
      <button
        className="flex h-[44px] w-[44px] items-center justify-center gap-8 rounded-[10px] bg-ph-violet-light"
        onClick={handleClickArrow}
      >
        <IoIosArrowRoundForward size={24} className="text-lg font-bold text-ph-gray-evening" />
      </button>
    </div>
  );
};

export default UserWalletMobileCard;
